<template>
  <div class="star-container" v-show="!calculating" :class="{'clickable':clickable}">
    <div
      v-for="(star,index) in starsObject"
      :key="index"
      :class="[star ? star : '', clickable ?'clickable': '']"
      @click="doRate(index)"
      class="star"
    ></div>
  </div>
</template>

<script src="./vdlBasicRatingStars.mjs"></script>
<style src="./vdlBasicRatingStars.scss" lang="scss" scoped></style>